module.exports = __webpack_public_path__ + "media/images/logo-light-ce2d6454023722c51cce9a0c45d8fd28.png";